<mat-card class="card" readOnly>
    <div class="row" *ngFor="let sensor of sensors">
        <div class="sensor-title">{{sensor.type | sensorDisplayName}}</div>
        <div class="actions-group">
            <div class="value-group">
                <div class="value-row day" *ngIf="sensor.type != 'power'">
                    <img src="../assets/images/day.svg" class="icon" *ngIf="dayNightAvailable">
                    <span
                          class="value">
                        {{sensor.alert.day && sensor.alert.day.min}}-{{sensor.alert.day && sensor.alert.day.max}}
                    </span>
                    <span class="format">{{sensor.type | sensorFormat}}</span>
                </div>
                <ng-container *ngIf="dayNightAvailable">
                    <div class="value-row night" *ngIf="sensor.type != 'power'">
                        <img src="../assets/images/night.svg" class="icon">
                        <span
                              class="value">{{sensor.alert.night && sensor.alert.night.min}}-{{sensor.alert.night &&
                            sensor.alert.night.max}}
                        </span>
                        <span class="format">{{sensor.type | sensorFormat}}</span>
                    </div>
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle"
                              [color]="'primary'"
                              [(ngModel)]="sensor.alert.active"
                              (change)="onNotificationChange(sensor)"
                              [disabled]="sensor.type != 'power' && sensor.alert._id === undefined">
            </mat-slide-toggle>
            <button readOnly [hide]="true" mat-button mat-icon-button onclick="this.blur()"
                    (click)="openAlertDialog(sensor)"
                    *ngIf="sensor.type != 'power'">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <div class="loading-wrapper" *ngIf="sensor.isLoading">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
    </div>

</mat-card>